import { createContext } from 'react';

export interface LeadConversionFlowContextValue {
    isComplete: boolean;
    complete: () => void;
}

export const LeadConversionFlowContext = createContext<LeadConversionFlowContextValue | null>(null);
